import React from "react";
import PropTypes from "prop-types";
import styles from "./SignalBadge.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignal } from "@fortawesome/free-solid-svg-icons";

/**
 * View component.
 * A signal icon with a badge indicating the signal level.
 */
export function SignalBadge({ signal }) {
  return (
    <div className={styles.container}>
      <FontAwesomeIcon icon={faSignal} className={styles.icon} />
      <span className={styles.badge}>{signal}</span>
    </div>
  );
}

SignalBadge.propTypes = {
  /**
   * Number that indicates the signal level.
   */
  signal: PropTypes.number,
};
